<template>
  <div class="min-height-for-section mb_controller w-100 pt-livetv bg-blur">
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="col-12">
          <div class="w-100">
            <h1>Soalan Lazim</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mt-4 mx-1 mx-md-3">
        <div class="col-12 text-left my-2 px-0 px-md-4">
          <div class="tabs">
            <div class="tab" v-for="(item, idx) in data" :key="idx">
              <input type="checkbox" :id="`chck${idx}`" />
              <label class="tab-label" :for="`chck${idx}`">{{
                item.title
              }}</label>
              <div class="tab-content">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 justify-content-center">
        <div class="col-12">
          <router-link
            :to="link"
            class="w-100 d-flex justify-content-center text-center"
          >
            <p class="">{{ linkTitle }}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
const english = [
  {
    title: "How to download RTMKlik on app store?",
    answer: "Search RTMKlik on Play Store, App Store and Huawei App Gallery.",
  },
  {
    title:
      "Why does my iPhone is not able to hear the audio from the RTMKlik application?",
    answer:
      "Please check on the iPhone left toggle switch. If it's on a silent mode, please switch to ring mode/ unmute to play the audio. Why is this happening: Due to iPhone system updates, etc",
  },
  {
    title: "Do I have to register RTMKlik to get started?",
    answer:
      "You can enjoy free live streaming, videos & radios on RTMKlik without registering with us. However to access Jom Tonton content, users must register.",
  },
  {
    title: "How to Sign-up RTMKlik",
    answer:
      "You can locate to the registration page in our website/application to register for free to enjoy our local TV shows, movies, series, live streaming, video-on-demand and more.",
  },
  {
    title: "What is Jadual (EPG)?",
    answer:
      "Jadual / EPG stands for 'Electronic Program Guide' for you to get an information about the featured & scheduled shows of all RTM's TV & Radio channels.",
  },
  {
    title: "Search box",
    answer:
      "You can search your favorite programme via few categories such as Titles, Actors & Year of that particular progeamme being uploaded.",
  },
  {
    title: "Can I change my email address?",
    answer:
      "Once you have registered via Google/Email/Apple ID, it is impossible to change the email address",
  },
  {
    title: "If I am a prepaid user, can I use RTMKLIK in my phone?",
    answer:
      "Yes, RTMKlik is available to use as long as there is an internet access.",
  },
  {
    title: "How can I contact RTMKlik?",
    answer:
      "You can locate to 'Hubungi kami' or 'Bantuan' right below the website/application",
  },
  {
    title: "Is my personal information secure while registering with RTMKlik",
    answer:
      "Yes, the latest technology including data encryption is used to protect the data submitted and adherence to strict security standards is applied to prevent unauthorized access.",
  },
  {
    title: "What is RTMKlik?",
    answer:
      "An application where you can enjoy Live channels, Video On Demand, Radio, Podcast and many more contents offered by RTM any time and anywhere",
  },
  {
    title: "What are the devices that I can use to stream RTMKlik?",
    answer:
      "You can have the freedom to stream videos through multiple devices by downloading the app on:1-Mobile: Android and iOS platforms,2-Desktop / Laptop,3-TV",
  },
];

const malay = [
  {
    title: "Bagaimana cara untuk muat turun aplikasi RTMKlik di App Store?",
    answer:
      "Buat carian RTMKlik di App Store, Play Store dan Huawei App Gallery.",
  },
  {
    title:
      "Kenapa iPhone saya tidak dapat untuk mendengar audio daripada aplikasi RTMKlik?",
    answer:
      "Boleh cek butang senyap di bahagian kiri iPhone. Jika berada di mod senyap boleh tukar kepada mod bunyi untuk mainkan audio. Bagaimana hal ini boleh terjadi: Disebabkan oleh sistem iPhone dan sebagainya. ",
  },
  {
    title: "Perlukah saya mendaftar RTMKlik untuk mengunakannya ?",
    answer:
      "Anda boleh menikmati siaran langsung, video - video, dan radio - radio di RTMKlik secara percuma  tanpa perlu mendaftar dengan kami. Namun untuk menonton konten Jom Tonton, penguna dihendaki untuk mendaftar. ",
  },
  {
    title: "Bagaimana untuk mendaftar di RTMKlik?",
    answer:
      "Anda boleh terus ke halaman pendaftaran di laman sesawang atau aplikasi kami untuk mendaftar secara percuma untuk menikmati rancangan TV tempatan, Movie, Siri, Siaran Langsung, Video On Demand dan lain-lain. ",
  },
  {
    title: "Apakah Jadual (EPG)? ",
    answer:
      "Jadual atau EPG terdiri daripada 'Electronic Program Guide' untuk anda mendapat maklumat mengenai kesemua rancangan TV RTM dan saluran - saluran radio yang dipaparkan dan dijadualkan. ",
  },
  {
    title: "Kotak Carian",
    answer:
      "Anda boleh mencari program kegemaran anda dibawah Kategori seperti Tajuk, Pelakon & Tahun program tersebut dimuat naik",
  },
  {
    title: "Bolehkah saya menukar alamat e-mel saya?",
    answer:
      "Tidak. Setelah anda mendaftar melalui Google/E-mel/ID Apple, menukar alamat e-mel adalah mustahil",
  },
  {
    title:
      "Jika saya pengguna prepaid, bolehkah saya tonton RTMKLIK di telefon saya?",
    answer: "Ya, RTMKlik boleh digunakan selagi terdapat internet.",
  },
  {
    title: "Bagaimana saya boleh hubungi RTMKlik?",
    answer:
      "Anda boleh layari 'Hubungi Kami' atau 'Bantuan' yang terdapat di laman sesawang dan aplikasi RTMKlik.",
  },
  {
    title: "Adakah maklumat peribadi saya selamat semasa berdaftar di RTMKlik?",
    answer:
      "Ya, teknologi terkini termasuk privasi data digunakan untuk melindungi data yang diisi dan menggunakan pematuhan kepada standard keselamatan yang ketat untuk mencegah akses yang tidak dibenarkan",
  },
  {
    title: "Apa itu RTMKlik?",
    answer:
      "RTMKlik adalah sebuah aplikasi di mana anda boleh menikmati Siaran Langsung, Video On Demand, Radio, Podcast dan banyak konten menarik yang ditawarkan oleh RTM pada bila-bila masa dan di mana sahaja ",
  },
  {
    title: "Gajet apakah yang boleh saya guna untuk melayari RTMKlik?",
    answer:
      "Anda bebas untuk strim video kami melalui berbilang gajet dengan memuat turun aplikasi RTMKlik di:1-Fon: Android dan iOS,2- Komputer/Komputer Riba,3- TV",
  },
];

export default {
  data: function() {
    return {
      english: english,
      malay: malay,
      data: [],
      lang: this.$route.params.lang,
      linkTitle: "",
      link: "",
    };
  },
  methods: {
    init() {
      if (this.lang === "bm") {
        this.data = this.malay;
      } else if (this.lang === "eng") {
        this.data = this.english;
      }

      this.linkTitle = this.lang === "bm" ? "English" : "Bahasa Malaysia";
      this.link = this.lang === "bm" ? "/soalan-lazim/eng" : "/soalan-lazim/bm";
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.pt-livetv {
  padding: 40px 0;
  min-height: 80vh;
}

/* Accordion styles */
.tabs {
  overflow: hidden;
}
label {
  margin: 0;
}
.tab {
  border-radius: 8px;
  width: 100%;
  color: white;
  overflow: hidden;
  margin-bottom: 16px;
}
.tab-label {
  font-family: Inter;
  display: flex;
  justify-content: space-between;
  padding: 16px;
  background: #1f1f1f;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.14;
  text-align: left;
  color: #fff;
  cursor: pointer;
  /* Icon */
}
.tab-label:hover {
  background: #dae130;
  color: #000000;
  font-family: Inter;
}
.tab-label::after {
  content: "❯";
  width: 1em;
  height: 1em;
  text-align: center;
  font-family: Inter;
  transition: all 0.25s;
}
.tab-content {
  max-height: 0;
  padding: 0 1em;
  font-family: Inter;
  font-size: 16px;
  line-height: 1.25;
  text-align: left;
  color: #fff;
  background: #1f1f1f;
  transition: all 0.25s;
}
.tab-close {
  display: flex;
  justify-content: flex-end;
  padding: 1em;
  font-size: 0.75em;
  background: #1f1f1f;
  cursor: pointer;
}
.tab-close:hover {
  background: #1a252f;
}

input:checked + .tab-label {
  background: #dae130;
  color: #000000;
}
input:checked + .tab-label::after {
  transform: rotate(90deg);
}
input:checked ~ .tab-content {
  max-height: 100vh;
  padding: 16px;
}
input[type="radio"],
input[type="checkbox"] {
  display: none !important;
}

h1 {
  font-family: Sf-ui-medium;
  font-size: 30px;
  font-weight: bold;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
p {
  font-family: Inter;
  font-size: 18px;
  line-height: 1.2;
  text-align: center;
  color: #dae12f;
}
</style>
